export default __webpack_public_path__ + "static/media/5_euros_account_type.c93ae9db.svg";